// "Achtung"-Kommentare ("Achtung Lieferung andere Adresse", "Achtung Prio
// geändert", …) sollen in den Terminlisten sofort ins Auge fallen.
// Trigger: Kommentar enthält "achtung" oder beginnt mit "!".
export function achtungKommentar(k: string | null | undefined): string | null {
  const t = (k ?? '').trim();
  if (!t) return null;
  return /achtung/i.test(t) || t.startsWith('!') ? t : null;
}
